/* Beard & Brawn — PDP buy-box behaviour (extracted from main-product.liquid, audit item 8).
   Two responsibilities, both scoped to a <product-info> section root and idempotent so
   theme-editor re-renders ('shopify:section:load') re-init cleanly:

     1. Mobile sticky Add-to-Cart bar — reveal once the inline buy-buttons scroll out
        of view, mirror the live price + selected-variant title, and reflect the inline
        submit button's loading state plus a brief "Added" confirmation (audit item 14).
     2. Cosmetic relabel of the Shopify placeholder "Default Title" / "Title" option.

   Liquid-only values are read from data-attributes on the section root:
     data-bb-base-title      — the product title (escaped)
     data-bb-has-placeholder — present when the product carries the "Default Title" placeholder
*/
(function () {
  'use strict';

  var INIT_FLAG = '__bbBuyboxInit';
  var ADDED_MS = 1600;

  function cleanText(el) {
    // Relabel a leaf node's "Default Title" -> "Standard" without disturbing nested
    // markup (e.g. the visually-hidden "sold out" span on pills).
    for (var i = 0; i < el.childNodes.length; i++) {
      var node = el.childNodes[i];
      if (node.nodeType === 3 && node.nodeValue.indexOf('Default Title') !== -1) {
        node.nodeValue = node.nodeValue.replace(/Default Title/g, 'Standard');
      }
    }
  }

  function relabelPlaceholder(root) {
    // 1) Hide the "Title" option legend/label in the variant picker.
    var picker = root.querySelector('variant-selects');
    if (picker) {
      var legends = picker.querySelectorAll('legend.form__label, label.form__label');
      for (var l = 0; l < legends.length; l++) {
        if ((legends[l].textContent || '').trim().replace(/:$/, '') === 'Title') {
          legends[l].style.display = 'none';
        }
      }
      // 2) Relabel "Default Title" pills, swatch legends, and <option>s.
      var pills = picker.querySelectorAll('label[for], option');
      for (var p = 0; p < pills.length; p++) {
        cleanText(pills[p]);
      }
    }
    // 3) Sticky bar shows the product TITLE, but guard in case a future change mirrors
    //    the variant value there.
    var stickyTitle = root.querySelector('.bb-sticky-atc__title');
    if (stickyTitle) cleanText(stickyTitle);
  }

  function initStickyAtc(root, sectionId) {
    var bar = root.querySelector('#StickyAtc-' + sectionId) || root.querySelector('.bb-sticky-atc');
    if (!bar) return;

    // Only run the observer on mobile widths; desktop is hidden via CSS.
    var mql = window.matchMedia('(max-width: 749px)');

    // The inline buy-buttons container we watch (Dawn renders <product-form> inside
    // .product-form__buttons).
    var inlineBuy =
      root.querySelector('product-form .product-form__buttons') ||
      root.querySelector('product-form') ||
      root.querySelector('.product-form__buttons');
    if (!inlineBuy) return;

    var observer = null;

    function show() { bar.classList.add('is-visible'); }
    function hide() { bar.classList.remove('is-visible'); }

    function startObserving() {
      if (observer || !mql.matches) return;
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          // Show the sticky bar only once the inline ATC has scrolled out of view.
          if (entry.isIntersecting) { hide(); } else { show(); }
        });
      }, { root: null, threshold: 0 });
      observer.observe(inlineBuy);
    }

    function stopObserving() {
      if (observer) { observer.disconnect(); observer = null; }
      hide();
    }

    function sync() {
      if (mql.matches) { startObserving(); } else { stopObserving(); }
    }

    sync();
    // matchMedia change (rotation / resize across the breakpoint)
    if (mql.addEventListener) {
      mql.addEventListener('change', sync);
    } else if (mql.addListener) {
      mql.addListener(sync);
    }

    // Keep the sticky price live: Dawn's product-info.js rewrites the inline
    // #price-<sectionId> innerHTML on variant change, so mirror it here.
    // It ALSO toggles the `hidden` class on that element — added by setUnavailable()
    // for an impossible option combination, cleared by handleUpdateProductInfo() for a
    // real variant. Mirror that class too, otherwise the sticky bar keeps showing a
    // STALE price for a combo that has no purchasable variant.
    var inlinePrice = root.querySelector('#price-' + sectionId);
    var stickyPrice = root.querySelector('#StickyAtcPrice-' + sectionId);
    if (inlinePrice && stickyPrice && 'MutationObserver' in window) {
      var syncStickyPrice = function () {
        stickyPrice.innerHTML = inlinePrice.innerHTML;
        // Hide the sticky price whenever the inline price is hidden (unavailable combo),
        // so the shopper never sees a price that doesn't apply to the current selection.
        stickyPrice.classList.toggle('hidden', inlinePrice.classList.contains('hidden'));
      };
      var priceObserver = new MutationObserver(syncStickyPrice);
      // childList/subtree: innerHTML rewrites. attributes/class: the hidden toggle.
      priceObserver.observe(inlinePrice, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class'],
      });
      // Reflect the initial state in case we wired up mid-flight.
      syncStickyPrice();
    }

    // Mirror the selected scent/variant into the sticky bar title so a mobile shopper
    // sees exactly what they're adding (e.g. "Beard Oil · Prospector").
    var stickyTitle = root.querySelector('.bb-sticky-atc__title');
    var baseTitle = root.getAttribute('data-bb-base-title') || '';
    function updateStickyTitle() {
      if (!stickyTitle) return;
      var inputs = root.querySelectorAll(
        '.product-form__input input[type="radio"]:checked, .product-form__input select'
      );
      var parts = [];
      for (var i = 0; i < inputs.length; i++) {
        var v = (inputs[i].value || '').trim();
        if (v && v !== 'Default Title') parts.push(v);
      }
      stickyTitle.textContent = parts.length ? baseTitle + ' · ' + parts.join(' · ') : baseTitle;
    }
    updateStickyTitle();
    root.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('.product-form__input')) {
        updateStickyTitle();
      }
    });

    // ---- Submit feedback + availability mirror (audit item 14c) -------------------
    // The sticky button is linked to the inline product form via form=..., so Dawn's
    // product-form.js handles the AJAX add. We mirror THREE independent inline signals
    // onto the sticky button so it always tells the truth:
    //   1. AVAILABILITY (authoritative): product-info.js's toggleSubmitButton() sets/
    //      clears the `disabled` ATTRIBUTE on the inline submit and swaps its <span>
    //      text to "Sold out" / "Unavailable" / "Add to cart" (localized via
    //      window.variantStrings). A sold-out/unavailable variant selected client-side
    //      would otherwise leave the sticky button enabled + labelled "Add to cart",
    //      OUTSIDE <product-form>, so tapping it submits a dead variant and the error
    //      renders off-screen — a silent failed add. We mirror the real disabled state
    //      + label so it can't happen.
    //   2. LOADING (transient): the inline submit gets a `loading` class + aria-disabled
    //      mid-add; mirror for keyboard/touch parity.
    //   3. ADDED (transient): flash a brief localized confirmation on cartUpdate.
    // Precedence: a live "Added ✓" flash wins briefly; otherwise availability decides
    // the resting label, and loading layers on top of an available button only.
    var stickyBtn = bar.querySelector('[data-sticky-atc-btn]') || bar.querySelector('.bb-sticky-atc__btn');
    if (stickyBtn) {
      var defaultLabel = stickyBtn.textContent.trim();
      // Prefer a localised success label from the button (main-product.liquid may
      // add data-added-label + a locale key); fall back to the English literal.
      var addedLabel = (stickyBtn.getAttribute('data-added-label') || '').trim() || 'Added ✓';
      var inlineSubmit = root.querySelector('#ProductSubmitButton-' + sectionId) ||
        root.querySelector('.product-form__submit');
      var addedTimer = null;
      // Set while THIS section's inline submit is mid-add, so we only flash "Added"
      // for adds that came from this product form (cartUpdate carries no section id).
      var pendingAdd = false;
      // Availability + loading state, resolved from the inline submit button.
      var soldOut = false;      // inline `disabled` attribute present
      var loading = false;      // inline `loading` class present
      var addedActive = false;  // "Added ✓" flash currently showing

      // Read the inline submit button's current visible label. Dawn writes the label
      // into the FIRST <span> (this.submitButtonText); read it so our sticky label
      // stays localized ("Sold out" / "Unavailable" / "Add to cart") instead of a
      // hardcoded English string. Fall back to the button's own default.
      function inlineLabel() {
        if (!inlineSubmit) return defaultLabel;
        var span = inlineSubmit.querySelector('span');
        var txt = ((span ? span.textContent : inlineSubmit.textContent) || '').trim();
        return txt || defaultLabel;
      }

      // Single source of truth for what the sticky button renders. Called on every
      // state change so no path (loading / added / availability) can clobber another.
      function render() {
        // The `disabled` ATTRIBUTE is driven ONLY by availability — a real <button>
        // with `disabled` fires no click/submit, so this natively blocks a sold-out
        // add. Loading uses aria-disabled + class (below) so it never leaves a
        // permanent `disabled` after an add settles.
        if (soldOut) {
          stickyBtn.setAttribute('disabled', 'disabled');
        } else {
          stickyBtn.removeAttribute('disabled');
        }
        // is-loading dim/spinner styling: shown while loading, or while sold-out so the
        // dimmed [disabled] styling already covers it (CSS ties [disabled] + .is-loading).
        stickyBtn.classList.toggle('is-loading', loading && !soldOut);
        // aria-disabled for AT: true when the button can't act on it (sold-out or busy).
        if (soldOut || loading) {
          stickyBtn.setAttribute('aria-disabled', 'true');
        } else {
          stickyBtn.removeAttribute('aria-disabled');
        }
        // Label precedence: transient "Added ✓" wins; else mirror the inline label
        // (sold-out/unavailable/add-to-cart) so the resting text is always correct and
        // localized. Don't fight the flash — it restores via render() when it clears.
        if (addedActive) {
          stickyBtn.textContent = addedLabel;
        } else {
          stickyBtn.textContent = soldOut ? inlineLabel() : defaultLabel;
        }
      }

      function flashAdded() {
        if (addedTimer) { clearTimeout(addedTimer); }
        addedActive = true;
        stickyBtn.classList.add('is-added');
        render();
        addedTimer = setTimeout(function () {
          addedActive = false;
          stickyBtn.classList.remove('is-added');
          addedTimer = null;
          render(); // resettle to the correct resting label (default OR sold-out)
        }, ADDED_MS);
      }

      // Mirror the inline submit button's state in real time. attributeFilter now
      // includes `disabled` (availability) alongside `class` (loading), so a client-
      // side switch to a sold-out variant flips the sticky button too.
      //   - Availability is keyed on the `disabled` ATTRIBUTE ONLY. In Dawn the two
      //     signals are cleanly split: toggleSubmitButton() (product-info.js) sets the
      //     `disabled` attribute for sold-out/unavailable, while the mid-add loading
      //     path (product-form.js onSubmitHandler) sets `aria-disabled=true` + the
      //     `loading` class and clears them in .finally(). So `aria-disabled` here means
      //     "busy", NOT "sold out" — folding it into soldOut would falsely flip the
      //     sticky button to a disabled "Sold out" during every normal add. We observe
      //     aria-disabled only to re-render promptly; `loading` (the class) carries it.
      function syncFromInline() {
        soldOut = inlineSubmit.hasAttribute('disabled');
        loading = inlineSubmit.classList.contains('loading');
        if (loading) pendingAdd = true;
        render();
      }
      if (inlineSubmit && 'MutationObserver' in window) {
        var stateObserver = new MutationObserver(syncFromInline);
        stateObserver.observe(inlineSubmit, {
          attributes: true,
          attributeFilter: ['class', 'disabled', 'aria-disabled'],
        });
        // Reflect the inline button's initial availability/loading immediately, in case
        // the page loaded with a sold-out default variant.
        syncFromInline();
      }

      // Belt-and-braces submit guard: a disabled <button> already suppresses click, but
      // stop the event if a sold-out/loading state is somehow reached, so a dead variant
      // can never be submitted (whose error would render off-screen and look silent).
      stickyBtn.addEventListener('click', function (e) {
        if (soldOut || loading ||
            stickyBtn.hasAttribute('disabled') ||
            stickyBtn.getAttribute('aria-disabled') === 'true') {
          e.preventDefault();
          e.stopPropagation();
        }
      });

      // Confirm on a successful cart add via Dawn's pubsub. pubsub.js / constants.js
      // are classic (non-module) globals, exposed as bare `subscribe` /
      // `PUB_SUB_EVENTS` (top-level const/function — NOT window properties), so
      // reference them via typeof guards. cartUpdate carries no section id, so gate
      // on our pendingAdd flag + source.
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        // subscribe() returns an unsubscribe fn. Stash it on the root so a later
        // re-init (Dawn swaps the whole <product-info> on combined-listing / URL
        // changes) can drop this handler — otherwise the closure pins the now
        // detached DOM forever (a zombie subscription + memory leak).
        root.__bbBuyboxUnsub = subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
          if (!pendingAdd) return;
          if (event && event.source && event.source !== 'product-form') return;
          pendingAdd = false;
          loading = false; // the add settled; drop the mirrored loading state
          flashAdded();
        });
      }
    }
  }

  // Roots we've wired, so a re-init (element swap) can unsubscribe the previous
  // instance's cartUpdate handler before wiring the fresh DOM.
  var wiredRoots = [];

  function teardown(root) {
    if (!root) return;
    if (typeof root.__bbBuyboxUnsub === 'function') {
      try { root.__bbBuyboxUnsub(); } catch (e) {}
      root.__bbBuyboxUnsub = null;
    }
    root[INIT_FLAG] = false;
    var idx = wiredRoots.indexOf(root);
    if (idx !== -1) wiredRoots.splice(idx, 1);
  }

  function init(root) {
    if (!root || root[INIT_FLAG]) return;
    root[INIT_FLAG] = true;
    if (wiredRoots.indexOf(root) === -1) wiredRoots.push(root);

    var sectionId = root.getAttribute('data-section');
    if (!sectionId) {
      // Fall back to parsing the id ("MainProduct-<id>").
      var idAttr = root.id || '';
      sectionId = idAttr.replace(/^MainProduct-/, '');
    }
    if (!sectionId) return;

    initStickyAtc(root, sectionId);

    if (root.hasAttribute('data-bb-has-placeholder')) {
      relabelPlaceholder(root);
    }
  }

  function initAll() {
    var roots = document.querySelectorAll('product-info[data-section]');
    for (var i = 0; i < roots.length; i++) { init(roots[i]); }
  }

  if (document.readyState !== 'loading') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  }

  // Dawn's product-info.js swaps the WHOLE <product-info> element on a
  // combined-listing / variant-URL change and dispatches a bubbling
  // 'product-info:loaded'. The DOMContentLoaded init above only ran once, so the
  // sticky bar would silently die on the fresh element and the old cartUpdate
  // subscription would zombie-hold the detached DOM. Re-init here: unsubscribe
  // every stale root (the previous element is detached, but its subscription is
  // still live), then wire the new one. The event target is the new element.
  document.addEventListener('product-info:loaded', function (e) {
    var fresh = e.target;
    if (!fresh || !fresh.matches || !fresh.matches('product-info')) return;
    // Drop any previously wired roots that are no longer connected (the swap
    // detaches them), plus the fresh one itself if it was somehow already wired.
    for (var i = wiredRoots.length - 1; i >= 0; i--) {
      var r = wiredRoots[i];
      if (r === fresh || !document.contains(r)) teardown(r);
    }
    init(fresh);
  });

  // Theme editor re-renders the section — re-init just that root cleanly.
  document.addEventListener('shopify:section:load', function (e) {
    var container = e.target;
    if (!container) return;
    var root = container.querySelector
      ? (container.matches && container.matches('product-info') ? container : container.querySelector('product-info[data-section]'))
      : null;
    if (root) {
      teardown(root); // fresh DOM from the re-render; drop any stale subscription + flag
      init(root);
    }
  });
})();
